import { ErrorHandler, Injectable } from '@angular/core';
import { FirebaseService } from '../firebase/firebase.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  constructor(private firebaseService: FirebaseService) { }

  handleError(error) {
    console.error(error);
    this.firebaseService.logError(error.message);
  }
}
